export const mockNewsList = [
  {
    id: "1",
    date: 1212121212,
    title: "News 1",
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
  },
  {
    id: "2",
    date: 1212121212,
    title: "News 2",
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
  },
  {
    id: "3",
    date: 1212121212,
    title: "News 3",
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
  },
];

export const mockNewsBoardList = [
  {
    id: "1",
    title: "News 1",
    date: 21212121212,
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
  },
  {
    id: "2",
    title: "News 2",
    date: 21212121212,
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
  },
  {
    id: "3",
    title: "News 3",
    date: 21212121212,
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
  },
];

export const mockContentPage = [
  {
    Id: 12,
    TitleE: "string",
    TitleA: "string",
    PageName: "string",
    IsActive: true,
    CreationDate: "2023-08-21T08:03:37.517Z",
    UpdateDate: "2023-08-21T08:03:37.517Z",
    CreatedBy: "string",
    UpdatedBy: "string",
    CMS_Content: [
      {
        Id: 12,
        PageId: 12,
        VersionNumber: 12,
        ContentTextE: "<ul><li>1</li><li>2</li></ul>",
        ContentTextA: "string",
        IsPublish: true,
        CreationDate: "2023-08-21T08:03:37.517Z",
        UpdateDate: "2023-08-21T08:03:37.517Z",
        CreatedBy: "string",
        UpdatedBy: "string",
      },
    ],
  },
];

export const mockNews = {
  Banner: "",
  News: [
    {
      Id: 12,
      Title: "string",
      ContentE: "string",
      ContentA: "string",
      CreationDate: "2023-08-21T08:03:37.517Z",
      UpdateDate: "2023-08-21T08:03:37.517Z",
      StartDate: "2023-08-21T08:03:37.517Z",
      EndDate: "2023-08-21T08:03:37.517Z",
      Urgency: true,
      IsActive: true,
      UpdatedBy: "string",
      CreatedBy: "string",
    },
    {
      Id: 13,
      Title: "string",
      ContentE: "string",
      ContentA: "string",
      CreationDate: "2023-08-21T08:03:37.517Z",
      UpdateDate: "2023-08-21T08:03:37.517Z",
      StartDate: "2023-08-21T08:03:37.517Z",
      EndDate: "2023-08-21T08:03:37.517Z",
      Urgency: true,
      IsActive: false,
      UpdatedBy: "string",
      CreatedBy: "string",
    },
    {
      Id: 14,
      Title: "string",
      ContentE: "string",
      ContentA: "string",
      CreationDate: "2023-08-21T08:03:37.517Z",
      UpdateDate: "2023-08-21T08:03:37.517Z",
      StartDate: "2023-08-21T08:03:37.517Z",
      EndDate: "2023-08-21T08:03:37.517Z",
      Urgency: true,
      IsActive: false,
      UpdatedBy: "string",
      CreatedBy: "string",
    },
    {
      Id: 15,
      Title: "string",
      ContentE: "string",
      ContentA: "string",
      CreationDate: "2023-08-21T08:03:37.517Z",
      UpdateDate: "2023-08-21T08:03:37.517Z",
      StartDate: "2023-08-21T08:03:37.517Z",
      EndDate: "2023-08-21T08:03:37.517Z",
      Urgency: false,
      IsActive: false,
      UpdatedBy: "string",
      CreatedBy: "string",
    },
    {
      Id: 16,
      Title: "string",
      ContentE: "string",
      ContentA: "string",
      CreationDate: "2023-08-21T08:03:37.517Z",
      UpdateDate: "2023-08-21T08:03:37.517Z",
      StartDate: "2023-08-21T08:03:37.517Z",
      EndDate: "2023-08-21T08:03:37.517Z",
      Urgency: false,
      IsActive: false,
      UpdatedBy: "string",
      CreatedBy: "string",
    },
    {
      Id: 17,
      Title: "string",
      ContentE: "string",
      ContentA: "string",
      CreationDate: "2023-08-21T08:03:37.517Z",
      UpdateDate: "2023-08-21T08:03:37.517Z",
      StartDate: "2023-08-21T08:03:37.517Z",
      EndDate: "2023-08-21T08:03:37.517Z",
      Urgency: false,
      IsActive: false,
      UpdatedBy: "string",
      CreatedBy: "string",
    },
  ],
};
